var OCS = OCS || {};
OCS.Chart = OCS.Chart || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.ExportGraph = {
    class_type: "graph",
    class_name: "ExportGraph",
    export_options: ['filename', 'type', 'scale'],
    svg: '',
    callback: Function.convert,
    get_export_options: function () {
        return Object.subset(this.options, this.export_options);
    },
    init_export_buttons: function () {
        // Removing print functionality for the time being.        
        Highcharts.getOptions().exporting.buttons.contextButton.menuItems = [
            {
//                textKey: 'printChart',
//                onclick: function () {
//                    this.print();
//                }
//            }, {
//                separator: true
//            }, {
                textKey: 'downloadPNG',
                onclick: function () {
                    this.export_chart({
                        type: 'image/png'
                    });
                }.bind(this)
            }, {
                textKey: 'downloadJPEG',
                onclick: function () {
                    this.export_chart({
                        type: 'image/jpeg'
                    });
                }.bind(this)
            }, {
                textKey: 'downloadSVG',
                onclick: function () {
                    this.export_chart({
                        type: 'image/svg+xml'
                    });
                }.bind(this)
            }, {
                textKey: 'downloadCSV',
                onclick: function () {
                    this.export_chart({
                        type: 'text/csv'
                    });
                    //this.downloadCSV();
                }.bind(this)
            }, {
                textKey: 'downloadXLS',
                onclick: function () {
                    this.export_chart({
                        type: 'text/xls'
                    });
                    //this.downloadXLS();
                }.bind(this)
            }
        ];
        this.fireEvent('export_buttons_added', this, 1);
    },
    request_svg: function (complete_callback) {
        if (complete_callback) {
            this.callback = complete_callback;
        }
        if (this.chart) {
            this.chart.getSVGForLocalExport(this.get_export_options(), {
                tooltip: {enable: false}
            }, function () {
                console.log("Failed to get SVG");
            }, function (svg) {
                this.svg_recieved(svg);
                this.export_chart_complete();
            }.bind(this));
        }
    },
    svg_recieved: function (svg) {
        if (svg) {
            this.svg = svg;
        }
    },
    get_svg: function () {
        return this.svg;
    },
    // Sends the chart in the requested format for the user to download to there machine
    download_svg: function () {
        if (this.svg) {
            Highcharts.downloadSVGLocal(this.svg,
                    {'filename': this.options.filename + '.' + (this.options.type === 'image/svg+xml' ? 'svg' : this.options.type.split('/')[1]), 'type': this.options.type, 'scale': this.options.scale},
                    function () {
                        console.log("Failed to export on client side");
                    }
            );
        } else {
            this.request_svg(this.download_svg.bind(this));
        }
    },
    // Export a single chart
    export_chart: function (options, complete_callback) {
        this.set_export_options(options);
        if (complete_callback) {
            this.callback = complete_callback;
        }

        // Process the export based on the requested type
        switch (this.options.type.split('/')[0]) {
            case 'text':
                this.process_text_export();
                break;
            default:
                this.process_image_export();
                break;
        }
        this.export_chart_complete();

    },
    set_export_options: function (ops) {
        this.setOptions(ops);
    },
    // All image export request are processed through here
    process_image_export: function () {
        if (!this.svg) {
            this.request_svg();
        }
    },

    // All text export request are processed through here
    process_text_export: function () {
        if (this.chart) {
            switch (this.options.type.split('/')[1]) {
                case 'csv':
                    this.chart.downloadCSV();
                    break;
                default:
                    this.chart.downloadXLS();
                    break;
            }
        }
    },
    // Pertinent for an image export, once complete test if we have a callback to fire
    export_chart_complete: function () {
        if (this.callback && this.svg) {
            // Send back the svg and the reference chart that this svg is associated with
            this.callback(this.svg, this);
        }
    }
};